// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"RangePage_overlayWrapper__rScTZ"};